import React from "react";
import { EditorModalType } from "./ComponentEditorContext";

interface ModalEditorContext {
  showModal: () => void;
  setModalContext: (path: string[], context: object, type: EditorModalType) => void;
  onCloseModal: () => void;
}

export const ModalEditorDisplayContext = React.createContext<ModalEditorContext>({
  showModal: () => {},
  setModalContext: () => {},
  onCloseModal: () => {},
});

export const useModalEditorDisplayContext = () => React.useContext(ModalEditorDisplayContext);
